import React, { Component } from "react";
import { connect } from "react-redux";
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Switch
} from "react-router-dom";

import { SkeletonActionCreators } from "../../actions/actionCreators";
import { ActionCreator } from "../../actions/actions";
import "../../api/api";
import AuthComponent from "../../modules/auth/components/AuthPage/Auth.component";
import ResetPwd from "../../modules/auth/components/ResetPwdPage/ResetPwdPage.component";
import HomePage from "../../modules/home/components/HomePage/HomePage.component";
import { API } from "../../api/api";
import { skeletonStoreSelectors } from "../../store";
import { Initializing } from "../Initializing/Initializing.component";

export interface SkeletonProps {
    initialize: ActionCreator;
    initialized: boolean;
}

const PrivateRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props =>
                API.getLoginStatus().loggedIn ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/login" />
                )
            }
        />
    );
};

class Skeleton extends Component<SkeletonProps, {}> {
    componentDidMount() {
        this.props.initialize();
    }

    render() {
        return this.props.initialized ? (
            <Router>
                <Route
                    render={({ location }) => (
                        <Switch location={location}>
                            <Route
                                exact
                                path="/login"
                                component={AuthComponent}
                            />
                            <Route
                                exact
                                path="/reset-password/:email/:token"
                                component={ResetPwd}
                            />
                            <PrivateRoute path="/" component={HomePage} />
                        </Switch>
                    )}
                />
            </Router>
        ) : (
            <Initializing />
        );
    }
}

const mapStateToProps = state => ({
    initialized: skeletonStoreSelectors.initialized(state)
});

const mapDispatchToProps = {
    initialize: SkeletonActionCreators.initialize
};

export default connect(mapStateToProps, mapDispatchToProps)(Skeleton);
